import Login from "./Login";
import Browse from "./Browse";
import { createHashRouter, createBrowserRouter, RouterProvider } from "react-router";
import Signup from "./Signup";

const Body = () => {
  const appRouter = createBrowserRouter([
    {
      path: "/browse",
      element: <Browse />,
    },
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/signup",
      element: <Signup />,
    },
  ]);

  return (
    <div>
      <RouterProvider router={appRouter}  />
    </div>
  );
};

export default Body;
